import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { CommissionsSignalmanModel } from '@/models/tables/commissions-signalman.model';
import { CommissionsSignalmanService } from '@services/data-source-tables/commissions-signalman.service';

@Component({
  selector: 'app-button-commission-signalman-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteCommissionSignalmanComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private commissionsSignalmanModel: CommissionsSignalmanModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected commissionsSignalmanService: CommissionsSignalmanService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.commissionsSignalmanModel = <CommissionsSignalmanModel>this.rowData;
  }

  /**
   * Delete commission
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteCommissions) => {
      if (deleteCommissions) {
        this.commissionsSignalmanService
          .deleteCommission(this.commissionsSignalmanModel.id)
          .subscribe({
            next: () => {
              this.toastr.success('Provvigione cancellata correttamente!');

              Registry.getInstance().get('CommissionSignalmanComponent').loadCommissions();
            },
            error: (error) => {
              LoggerService.error('deleteCommission failed!');
              LoggerService.error(error);

              this.toastr.error(`Errore durante la cancellazione della provvigione.`);
            },
            complete: () => {
              LoggerService.log('Request done');
            },
          });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa provvigione?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata la provvigione non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
